import { render, staticRenderFns } from "./Host.vue?vue&type=template&id=e80e8b8e&scoped=true&"
import script from "./Host.vue?vue&type=script&lang=js&"
export * from "./Host.vue?vue&type=script&lang=js&"
import style0 from "./Host.vue?vue&type=style&index=0&id=e80e8b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80e8b8e",
  null
  
)

export default component.exports